import { createSlice } from "@reduxjs/toolkit";
import { getForums } from "./_forumAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const forumList = createSlice({
  name: "forumList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getForums.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getForums.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getForums.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
